import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_jcprcjpc8n: FaireCollectionEntity = {
  token: "pbc_jcprcjpc8n",
  type: "collection",
  name: "Farm & Sheep Organic Baby Clothing Collection--Spring/Summer",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c81ac1c53c3b84f0545f1f2130cb4fcb1d2c5fd7e655cb1a81938113ac60a852.jpeg",
  itemCount: 30,
  description:
    "Charming farm- and sheep-themed apparel, blankets, and toys for Spring/Summer—ethically crafted with organic cotton grown by small farmers in India.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:20.196Z",
    importedBy: "entity-db-import-collections",
  },
};
